import {
  Box,
  Image,
  VStack,
  Flex,
  Spinner,
  Button,
  Text,
} from "@chakra-ui/react";
import { LinkText, StyledCheckboxText } from "@root/commonStyles/commonStyle";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { StyledAuthLinkOrTextBox } from "../login/styles";
import {
  EmailVerificationContainer,
  StyledSignupHeading,
  StyledSignupSubHeading,
  StyledSignupDescription,
  StyledDescription,
  StyledInboxLink,
} from "./styles";
import EmailVerificationSVG from "@root/assets/images/emailVerification.svg";
import { useDispatch, useSelector } from "react-redux";
import { getPasswordRecoverEmail } from "@root/store/selectors/entities";
import { resendEmail, resetPass } from "@root/store/thunks";
import { LanguageToggle } from "@root/components/dashboard/sidebar/languagetoggler";

export const EmailVerification: React.FC = () => {
  const givenEmail: any = useSelector(getPasswordRecoverEmail);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const onSuccess = () => {
    setLoading(false);
  };

  const isResetting: boolean = givenEmail?.redirect_url;
  const onResend = () => {
    setLoading(true);
    if (isResetting) {
      dispatch(
        resetPass({
          payload: givenEmail,
          onSuccess,
          onError: () => setLoading(false),
        })
      );
    } else {
      dispatch(
        resendEmail({
          payload: givenEmail,
          onSuccess,
          onError: () => setLoading(false),
        })
      );
    }
  };

  const { t } = useTranslation("common");

  const RenderContent = (
    loading: boolean,
    onResend: () => void,
    t: TFunction
  ) => {
    const invokeOnClick = () => {
      onResend();
    };

    if (loading) {
      return (
        <Flex my={"20px"}>
          <Spinner />
        </Flex>
      );
    } else {
      return (
        <Box>
          <Button
            onClick={invokeOnClick}
            sx={{
              color: "gray.neutral",
              fontSize: "12px",
              fontWeight: "500",
              lineHeight: "normal",
              background: "transparent",
              _hover: { background: "transparent" },
              _focus: { boxShadow: "none" },
              size: "sm",
              width: "0px",
              mx: "10px",
            }}
          >
            다시 보내기
          </Button>
        </Box>
      );
    }
  };

  return (
    <Box position="relative">
      <LanguageToggle variant="public" position="absolute" top="20px" right="20px" />
      <EmailVerificationContainer>
        <StyledSignupHeading>{t("signup.title")}</StyledSignupHeading>
        <StyledSignupSubHeading>
          <Text as="span" color="purple.500">
            {t("login.subTitle")}
          </Text>{" "}
          <Text as="span" color="black">
            {t("login.subtitle_1")}
          </Text>{" "}
          <Text as="span" color="purple.500">
            {t("login.subtitle_2")}
          </Text>
        </StyledSignupSubHeading>
        <StyledSignupDescription>
          {t("signup.description")}
        </StyledSignupDescription>
        <StyledSignupDescription>
          {t("signup.description_1")}
        </StyledSignupDescription>

        <VStack
          mt="40px"
          spacing={"16px"}
          align="center"
          border="1px solid"
          borderColor="#E6E9EF"
          borderRadius="24px"
          p="24px"
          width={{ base: "100%", md: "85%", lg: "95%" }}
          shadow="lg"
        >
          <Image src={EmailVerificationSVG} alt="Lock" />
          <StyledSignupDescription>
            {t("emailVerification.description2")}
          </StyledSignupDescription>
          <Box fontSize="16" fontWeight="500" color={"purple.500"}>
            {givenEmail?.email}
          </Box>

          <StyledInboxLink>
            <StyledDescription>
              {t("emailVerification.subDescription")}
            </StyledDescription>

            {RenderContent(loading, onResend, t)}
          </StyledInboxLink>
        </VStack>

        <StyledAuthLinkOrTextBox>
          <StyledCheckboxText>{t("signup.alreadyAccount")}</StyledCheckboxText>
          <LinkText to={"/login"} color={"purple.500"}>
            {t("login.loginLink")}
          </LinkText>
        </StyledAuthLinkOrTextBox>
      </EmailVerificationContainer>
    </Box>
  );
};
